export default "/images/vendor/flag-icon-css/flags/1x1/do.svg?3ecb625b75ec64be437600e7a9f4ed47";